import { atom } from 'jotai';
export const $WebUser = atom({
    webId: '',
});
$WebUser.debugLabel = '$WebUser';
